const Jt = {};

const hasOwnProperty = Object.prototype.hasOwnProperty;

Jt.base = {
    isObject(o) {
        return o && (o.constructor === Object || Object.prototype.toString.call(o) === "[object Object]");
    },
    isArray(o) {
        return o && (o.constructor === Array || Object.prototype.toString.call(o) === "[object Array]");
    },
    isEmpty(o) {
        if(this.isArray(o) && o.length) {
            return false;
        } else if(this.isObject(o)) {
            for(let key in o) {
                if(hasOwnProperty.call(o, key)) {
                    return false;
                }
            }
            return true;
        } else if(o) {
            return false;
        }
        return true;
    }
};

Jt.array = {
    difference(arr1, arr2) {
        const res = [];
        for(let i = 0, len = arr1.length; i < len; i++) {
            if(arr2.indexOf(arr1[i]) === -1) {
                res.push(arr1[i]);
            }
        }
        return res;
    }
};

Jt.dom = (function() {

    function getStyle(el, attr) {
        if(typeof window.getComputedStyle !== 'undefined') {
            return window.getComputedStyle(el, null)[attr]
        } else if(typeof Element.currentStyle !== 'undefined') {
            return el.currentStyle[attr]
        }
    }

    function attr(el, attr, val) {
        if(typeof attr === 'object') {
            for(let i in attr) {
                el.setAttribute(i, attr[i])
            }
        } else {
            if(arguments.length === 2) {
                return el.getAttribute(attr)
            }
            el.setAttribute(attr, val)
        }
    }

    function css(el, attr, val) {
        if(typeof attr === 'object') {
            for(let i in attr) {
                el.style[i] = attr[i]
            }
        } else {
            if(arguments.length === 2) {
                return getStyle(el, attr)
            }
            el.style[attr] = val
        }
    }

    function hasClass(el, className) {
        if(!el || !className) {
            return false
        }
        return el.classList.contains(className)
    }

    function addClass(el, className) {
        if(!el || !className || hasClass(el, className)) {
            return;
        }
        el.classList.add(className)
    }

    function removeClass(el, className) {
        if(!el || !className || !hasClass(el, className)) {
            return
        }
        el.classList.remove(className)
    }

    function offset(el) {
        if(!el || el.nodeType !== 1) {
            return {top: 0, left: 0};
        }
        const rect = el.getBoundingClientRect();
        const win = el.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    }

    return {
        attr,
        css,
        hasClass,
        addClass,
        removeClass,
        offset
    }
})();

Jt.file = {
    formatSize(size, pointLength, units) {
        let unit;
        units = units || [ 'B', 'K', 'M', 'G', 'TB' ];
        while ((unit = units.shift()) && size > 1024) {
            size = size / 1024;
        }
        return (unit === 'B' ? size : size.toFixed( pointLength || 2 )) + unit;
    }
};

Jt.loader = {
    removeExistFiles(tag, urls) {
        const files = document.getElementsByTagName(tag);
        const type = tag === 'script' ? 'src' : 'href';
        const paths = [];
        for(let i = 0, len = files.length; i < len; i++) {
            paths.push(files[i].getAttribute(type));
        }
        return Jt.array.difference(urls, paths);
    },
    loadScripts(scripts, callback, parent = 'body') {
        scripts = Jt.loader.removeExistFiles('script', scripts);
        if(scripts.length === 0) {
            callback && callback();
            return;
        }
        parent = document.getElementsByTagName(parent)[0] || document.documentElement;
        let loaded = 0;
        for(let i = 0, len = scripts.length; i < len; i++) {
            let node = document.createElement('script');
            node.onload = node.onreadystatechange = function() {
                const rs = this.readyState;
                if('undefined' === typeof rs || 'loaded' === rs || 'complete' === rs) {
                    loaded++;
                    this.onload = this.onreadystatechange = null;
                    node = null;
                    if(loaded === scripts.length) {
                        callback && callback();
                    }
                }
            }
            node.src = scripts[i];
            parent.appendChild(node);
        }
    }
};

export default Jt;



// WEBPACK FOOTER //
// ./src/utils/jt.js